import { Navigate } from "react-router-dom"; 
import { useContext } from "react";
import AuthContext from "../context/AuthContext";  

const PrivateRoute = ({ children }) => {
  const { user } = useContext(AuthContext); 
  // Si l'utilisateur n'est pas authentifié, rediriger vers la page de connexionxion
  return user ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
